import { PageType, PageTypes } from 'strapi/page/types';
import { RequestParams } from 'strapi/types';

import { ChildrenListStrapiComponent } from './types';

export const childrenListParams: (type: PageType) => RequestParams<
  PageTypes & {
    childrenList: ChildrenListStrapiComponent;
  }
> = (type: PageType) => {
  if (type === PageType.MockupParentPage) {
    return {
      populate: {
        childrenList: true,
        mockup_child_pages: {
          fields: ['path', 'slug', 'cover', 'descriptiveName'],
          populate: { cover: true },
        },
      },
    };
  }

  if (type === PageType.AiWritingToolParentPage) {
    return {
      populate: {
        childrenList: true,
        ai_writing_child_pages: {
          fields: ['path', 'slug', 'cover', 'descriptiveName'],
          populate: { cover: true },
        },
      },
    };
  }
  return {};
};
